import Alert from 'flarum/common/components/Alert';

class ContainedAlert extends Alert {
    view(vnode) {
        const vdom = super.view(vnode);
        return { ...vdom, children: [<div className="container">{vdom.children}</div>] };
    }
}

export const showAlert = (info = '') => {
    if (app.data['datitisev-maintenance.active']) {
        m.mount($('<div/>').insertBefore('#content')[0], {
            view: () => (
                <ContainedAlert dismissible={false}>
                    <span>
                        {app.translator.trans('datitisev-maintenance.lib.maintenance_active_message')} {info}
                    </span>
                </ContainedAlert>
            ),
        });
    }
};
